export const CAPI_PAGEVIEW_ENDPOINT = "/pageview";
export const CAPI_EVENT_ENDPOINT = "/event";
